import React, { useState, useRef, useEffect } from "react";
import styles from "../TeachingListview.module.css";
// import "../Profile.css";
import "../FacultyDatePicker.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import jsPDF from "jspdf";
import "jspdf-autotable";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
// import moment from "moment";
import { R_PER_PAGE } from "../../../../../labels";
import { AxiosInstance } from "../../../../../axios";
import CustomDownloadButton from "../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import Loader from "../../../Loader";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import DatePickerSample from "../../../DatePicker";
// import { Subject } from "@mui/icons-material";

function TeachingProgress(props) {
  const navigate = useNavigate();
  const moment = require("moment-timezone");
  const txtBSearch = useRef(null);
  const filterLastRef = useRef(null);
  const percentage_of_completion = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const filterCategoryRef = useRef(null);
  const filterClassModeRef = useRef(null);
  const filterRef_medium = useRef(null);
  const filterLocationRef = useRef(null);
  const locations = useLocation();

  const {
    fil_date,
    fil_percen,
    fil_cate,
    fil_search,
    fil_sub,
    fil_tes_topic,
    fil_medium,
    fil_class,
    fil_loc,
  } = locations.state || [];

  const filterRef_subject = useRef(null);
  const filterRef_test_topic = useRef(null);
  const { userId } = useParams();

  const params = useParams();

  // List data load table
  let page = R_PER_PAGE;
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let role_id = null;
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      role_id = user.role_id;
      user_type = user.user_type;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  // use state\
  const [initialfields, setInitialfields] = useState({
    fromDate: "",
    toDate: "",
  });
  const [categoryId, setCategoryId] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);
  const [test_on, setTest_on] = useState([]);
  const [testIds, setTestIds] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isLoading, setIsLoading] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [updateListData, setUpdateListData] = useState([]);
  const [csvListData, setCsvListData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [isOpen, setIsOpen] = useState({
    status: false,
    startDate: false,
    schedule: false,
    Percentage: false,
    category: false,
    // course:false,
    subject: false,
    test_topic: false,
    medium: false,
    classMode: false,
    location: false,
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const [updateChipData, setUpdateChipData] = useState([]);

  const [status, setStatus] = useState([]);
  const [location, setLocation] = useState([]);
  const [appOn, setAppOn] = useState([]);

  const [schedule, setSchedule] = useState([]);
  const [classModes, setClassModes] = useState([]);
  const [mediums, setMedium] = useState([]);
  let filterStatus = [];
  let filterCategory = [];
  let filterSchedule = [];
  let filterClassMode = [];
  let filterLocation = [];
  let filterMedium = [];
  let filterApplyed = [];
  let filterSearch = [];
  let filterSubject = [];
  let filterTest = [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterLastRef.current &&
        !filterLastRef.current.contains(event.target)
      ) {
        const mismatchedDay = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData.Days
        );
        if (mismatchedDay) {
          setAppData({
            FDate: "",
            TDate: "",
            Days: mismatchedDay.Days,
          });
          setAppOn([
            {
              FDate: "",
              TDate: "",
              Days: mismatchedDay.Days,
            },
          ]);
        } else {
          const mismatchedDate = updateChipData.find(
            (chipItem) =>
              chipItem.fdate === appData.FDate &&
              chipItem.edate === appData.TDate
          );
          if (mismatchedDate) {
            setAppData((prev) => ({
              ...prev,
              FDate: mismatchedDate.fdate,
              TDate: mismatchedDate.edate,
              Days: "",
            }));
            setAppOn([
              {
                FDate: mismatchedDate.fdate,
                TDate: mismatchedDate.edate,
                Days: "",
              },
            ]);
          } else {
            setAppData({
              FDate: "",
              TDate: "",
              Days: "",
            });
            setAppOn([]);
          }
        }
        setIsOpen((prev) => ({ ...prev, startDate: false }));
      }
      if (
        percentage_of_completion.current &&
        !percentage_of_completion.current.contains(event.target)
      ) {
        {
          const hasPercent = updateChipData.some(
            (chipItem) => chipItem.type === "Percentage"
          );
          if (hasPercent) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "Percentage"
            );
            // alert("1")
            const [fromDate, toDate] = updatedAuthor[0].name
              .split(" - ")
              .map((val) => val.trim());

            setInitialfields({ fromDate, toDate });
          } else {
            // alert("2")

            setInitialfields({ fromDate: "", toDate: "" });
          }
          setIsOpen((prev) => ({ ...prev, Percentage: false }));
        }
      }
      if (
        filterCategoryRef.current &&
        !filterCategoryRef.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "category"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "category"
            );
            setCategory_on(updatedCategory);
          } else {
            setCategory_on([]);
          }
          setIsOpen((prev) => ({ ...prev, category: false }));
        }
      }
      if (
        filterRef_subject.current &&
        !filterRef_subject.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "subject"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "subject"
            );
            setSubject_on(updatedCategory);
          } else {
            setSubject_on([]);
          }
          setIsOpen((prev) => ({ ...prev, subject: false }));
        }
      }
      if (
        filterRef_test_topic.current &&
        !filterRef_test_topic.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "test_topic"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "test_topic"
            );
            setTest_on(updatedCategory);
          } else {
            setTest_on([]);
          }
          setIsOpen((prev) => ({ ...prev, test_topic: false }));
        }
      }
      if (
        filterClassModeRef.current &&
        !filterClassModeRef.current.contains(event.target)
      ) {
        {
          const hasclassMode = updateChipData.some(
            (chipItem) => chipItem.type === "classMode"
          );
          if (hasclassMode) {
            const hasclassMode = updateChipData.filter(
              (chipItem) => chipItem.type === "classMode"
            );
            setClassModes(hasclassMode);
          } else {
            setClassModes([]);
          }
          setIsOpen((prev) => ({ ...prev, classMode: false }));
        }
      }
      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium(updatedCategory);
          } else {
            setMedium([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }
      if (
        filterLocationRef.current &&
        !filterLocationRef.current.contains(event.target)
      ) {
        {
          const hasclassMode = updateChipData.some(
            (chipItem) => chipItem.type === "location"
          );
          if (hasclassMode) {
            const hasclassMode = updateChipData.filter(
              (chipItem) => chipItem.type === "location"
            );
            setLocation(hasclassMode);
          } else {
            setLocation([]);
          }
          setIsOpen((prev) => ({ ...prev, location: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, category_on, subject_on, mediums]);

  useEffect(() => {
    if (fil_search && fil_search.length > 0) {
      searchTerm(fil_search);
      filterSearch = fil_search;
    }
    if (fil_date && fil_date.length > 0) {
      setAppOn(fil_date);
      filterApplyed = fil_date;
    }
    if (fil_cate && fil_cate.length > 0) {
      setCategory_on(fil_cate);
      filterCategory = fil_cate;
    }

    if (fil_sub && fil_sub.length > 0) {
      setSubject_on(fil_sub);
      filterSubject = fil_sub;
    }
    if (fil_tes_topic && fil_tes_topic.length > 0) {
      setTest_on(fil_tes_topic);
      filterTest = fil_tes_topic;
    }

    if (fil_class && fil_class.length > 0) {
      setClassModes(fil_class);
      filterClassMode = fil_class;
    }
    if (fil_medium && fil_medium.length > 0) {
      setMedium(fil_medium);
      filterMedium = fil_medium;
    }
    if (fil_loc && fil_loc.length > 0) {
      setLocation(fil_loc);
      filterLocation = fil_loc;
    }

    loadChipdata();
  }, []);
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);
  useEffect(() => {
    filterStatus = status;
  }, [status]);
  useEffect(() => {
    filterLocation = location;
  }, [location]);
  useEffect(() => {
    filterClassMode = classModes;
  }, [classModes]);
  useEffect(() => {
    filterSchedule = schedule;
  }, [schedule]);

  useEffect(() => {
    filterMedium = mediums;
  }, [mediums]);

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);

  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);

  useEffect(() => {
    filterSubject = subject_on;
  }, [subject_on]);
  useEffect(() => {
    filterTest = test_on;
  }, [test_on]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);

  function updateStateData() {
    filterStatus = status;
    filterCategory = category_on;
    filterApplyed = appOn;
    filterSchedule = schedule;
    filterSubject = subject_on;
    filterTest = test_on;
    filterLocation = location;
    filterClassMode = classModes;
    filterMedium = mediums;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleChange = (event) => {
    let { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  // filter checkbox update

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (name === "Upcoming" || name === "Ongoing" || name === "Completed") {
      if (checked) {
        // setStatus([...status, value]);
        setStatus([...status, { id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    } else if (names === "location") {
      if (checked) {
        // setStatus([...status, value]);
        setLocation([...location, { id: value, name: name, type: "location" }]);
      } else {
        setLocation(location.filter((item) => item.id !== value));
      }
    } else if (name === "Weekend" || name === "Regular") {
      if (checked) {
        setSchedule([...schedule, { id: value, name: name, type: "schedule" }]);
      } else {
        setSchedule(schedule.filter((item) => item.id !== value));
      }
    } else if (name === "Classroom" || name === "Online") {
      if (checked) {
        setClassModes([
          ...classModes,
          { id: value, name: name, type: "classMode" },
        ]);
      } else {
        setClassModes(classModes.filter((item) => item.id !== value));
      }
    } else if (name === "English" || name === "Tamil") {
      if (checked) {
        setMedium([...mediums, { id: value, name: name, type: "medium" }]);
      } else {
        setMedium(mediums.filter((item) => item.id !== value));
      }
    } else if (typename === "category") {
      if (checked) {
        setCategory_on([
          ...category_on,
          { id: value, name: name, type: "category" },
        ]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([
          ...subject_on,
          { id: value, name: name, type: "subject" },
        ]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    } else if (typename === "test_topic") {
      if (checked) {
        setTest_on([...test_on, { id: value, name: name, type: "test_topic" }]);
      } else {
        setTest_on(test_on.filter((item) => item.id !== value));
      }
    }
  };

  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        KeyCode: 13,
        which: 13,
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setInitialfields({});
    setStatus([]);
    setSchedule([]);
    setLocation([]);
    setClassModes([]);
    setUpdateChipData([]);
    setAppOn([]);
    setSubject_on([]);
    setTest_on([]);
    setMedium([]);
    setCategory_on([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setUpdateListData([]);
  };

  // filter apply button

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "location") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        location: false,
      });
    } else if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "schedule") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        schedule: false,
      });
    } else if (name === "Percentage") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        Percentage: false,
      });
    } else if (name === "classMode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        classMode: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "test_topic") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        test_topic: false,
      });
    }
  };

  function loadListdata() {
    let tempstatus = [];
    let tempCategory = [];
    let tempsche = [];
    let tempPercent = [];
    let tempclassMode = [];
    let tempLocanum = [];
    let templocation = [];
    let tempMedium = [];
    let tempSubject = [];
    let tempTestTopic = [];
    status.map((obj) => {
      tempstatus.push(obj.id);
    });

    location.map((obj) => {
      templocation.push(obj.id);
    });

    classModes.map((obj) => {
      tempclassMode.push(obj.name);
    });

    mediums.map((obj) => {
      tempMedium.push(obj.name);
    });

    schedule.map((obj) => {
      tempsche.push(obj.name);
    });

    category_on.map((obj) => {
      tempCategory.push(obj.name);
    });
    subject_on.map((obj) => {
      tempSubject.push(obj.id);
    });
    test_on.map((obj) => {
      tempTestTopic.push(obj.id);
    });

    tempLocanum = templocation.map(Number);

    let statusFilter = {
      category: category_on.length > 0 ? tempCategory : "",
      medium: mediums.length > 0 ? tempMedium : "",
      class_mode: classModes.length > 0 ? tempclassMode : "",
      start_date: appOn.length > 0 ? appOn[0].fdate + " 00:00:00" : "",
      end_date: appOn.length > 0 ? appOn[0].edate + " 23:59:00" : "",
      start_time: "",
      end_time: "",
      staff_id: props.staff_id,
      start_perc: initialfields.fromDate || "",
      end_perc: initialfields.toDate || "",
      location: location.length > 0 ? tempLocanum : "",
      subject: subject_on.length > 0 ? tempSubject : "",
      test_topic: test_on.length > 0 ? tempTestTopic : "",
      search: searchTerm.length > 0 ? searchTerm : "",
    };

    setIsLoading(true);

    AxiosInstance.post("api/staff/teachProg/list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          // setUpdateListData(fiata);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            event_name: item.event_name,
            date: item.date,
            completed_perc: item.completed_perc,
            batch_name: item.batch_name,
            category: item.category,
            class_mode: item.class_mode === 1 ? "Online" : "ClassRoom",
            medium: item.medium === 0 ? "English" : "Tamil",
            location: item.location,
          }));
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);
          const uniqueLocations = [];
          const seen = new Set();

          serialNumberAddedData.forEach((item) => {
            const loc = item;
            const locationValue = loc?.location?.trim();

            if (locationValue && !seen.has(locationValue)) {
              seen.add(locationValue);
              uniqueLocations.push(loc);
            }
          });

          const options = uniqueLocations.map((loc, index) => ({
            label: loc?.location,
            value: loc?.location_id,
          }));

          setLocationOptions(options);

          const csvData = fiata.map((el) => {
            return {
              date: el.date,
              completed_perc: el.completed_perc,
              batch_name: el.batch_name,
              category: el.category,
              class_mode: el.class_mode,
              medium: el.medium,
              location: el.location,
            };
          });
          setCsvListData(csvData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setUpdateListData([]);
        return error;
      });
  }
  function getAPCSData(data) {
    if (data.length > 0) {
      const seenSubjectIds = new Set();
      const uniqueSubjects = [];
      const seenTestTopicIds = new Set();
      const uniqueTestTopic = [];
      data.forEach((item) => {
        item.subject.forEach((subj) => {
          if (!seenSubjectIds.has(subj.subject_pk)) {
            seenSubjectIds.add(subj.subject_pk);
            uniqueSubjects.push({
              subject_name: subj.subject,
              subject_id: subj.subject_pk,
            });
          }
        });
      });
      setSubjectIds(uniqueSubjects);

      data.forEach((item) => {
        item.test_topic.forEach((topic) => {
          if (!seenTestTopicIds.has(topic.test_topic_pk)) {
            seenTestTopicIds.add(topic.test_topic_pk);
            uniqueTestTopic.push({
              test_topic_name: topic.test_topic,
              test_topic_id: topic.test_topic_pk,
            });
          }
        });
      });

      setTestIds(uniqueTestTopic);
    }
  }

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    if (initialfields.fromDate || initialfields.toDate) {
      tempArr.push({
        name: `${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
        value: `MRP`,
        type: "Percentage",
      });
    }
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });

    filterLocation.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filterTest.map((obj) => {
      tempArr.push(obj);
    });

    filterCategory.map((obj) => {
      tempArr.push(obj);
    });

    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });

    filterSchedule.map((obj) => {
      tempArr.push(obj);
    });

    filterClassMode.map((obj) => {
      tempArr.push(obj);
    });

    filterMedium.map((obj) => {
      tempArr.push(obj);
    });

    setUpdateChipData(tempArr);
  }

  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => ({ ...prevState, [name]: value }));
      const from = name === "FDate" ? value : appData.FDate;
      const to = name === "TDate" ? value : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    } else if (name === "Days") {
      if (checked) {
        setAppData((prevState) => ({ ...prevState, [name]: value }));
      }
      // else {
      //   setAppOn(appOn.filter((item) => item !== value));
      // }
      if (value === "Today") {
        const today = new Date();
        setAppOn([
          {
            name: value,
            fdate: moment(today.toDateString()).format("YYYY-MM-DD"),
            edate: moment(today.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Yesterday") {
        const today = new Date(); // Get today's date
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        setAppOn([
          {
            name: value,
            fdate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            edate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tweek") {
        const today = new Date(); // Get today's date
        const thisWeekStartDate = moment(today)
          .subtract(0, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const thisWeekEndDate = moment(today)
          .subtract(0, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "This week",
            fdate: moment(thisWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lweek") {
        const today = new Date(); // Get today's date
        const lastWeekStartDate = moment(today)
          .subtract(1, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const lastWeekEndDate = moment(today)
          .subtract(1, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "Last week",
            fdate: moment(lastWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tmonth") {
        const today = new Date(); // Get today's date
        const thisMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        ); // Get start date of this month
        const thisMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        setAppOn([
          {
            name: "This month",
            fdate: moment(thisMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lmonth") {
        const today = new Date();
        const lastMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const lastMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        setAppOn([
          {
            name: "Last month",
            fdate: moment(lastMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      }
    }
  };
  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "status") {
      // Clear the status array
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "category") {
      setCategory_on([]);
      filterCategory = [];

      setIsOpen({
        ...isOpen,
        type: false,
      });
    } else if (name === "subject") {
      setSubject_on([]);
      filterSubject = [];
    } else if (name === "test_topic") {
      setSubject_on([]);
      filterTest = [];
    } else if (name === "schedule") {
      setSchedule([]);
      filterSchedule = [];

      setIsOpen({
        ...isOpen,
        schedule: false,
      });
    } else if (name === "Percentage") {
      setInitialfields({});
      setIsOpen({
        ...isOpen,
        Percentage: false,
      });
    } else if (name === "classMode") {
      setClassModes([]);
      filterClassMode = [];

      setIsOpen({
        ...isOpen,
        classMode: false,
      });
    } else if (name === "medium") {
      setMedium([]);
      filterMedium = [];

      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "location") {
      // Clear the status array
      setLocation([]);
      filterLocation = [];
      setIsOpen({
        ...isOpen,
        location: false,
      });
    }
    loadChipdata();
  };

  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    let shouldReloadChipData = true;
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "location") {
      setLocation(location.filter((item) => item.id !== chipToDelete.id));
      filterLocation = location.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "category") {
      setCategory_on(
        category_on.filter((item) => item.name !== chipToDelete.name)
      );
      filterCategory = category_on.filter(
        (item) => item.name !== chipToDelete.name
      );
    } else if (chipToDelete.type === "dayRange") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else if (chipToDelete.type === "schedule") {
      setSchedule(schedule.filter((item) => item.id !== chipToDelete.id));
      filterSchedule = schedule.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "subject") {
      setSubject_on(subject_on.filter((item) => item.id !== chipToDelete.id));
      filterSubject = subject_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "test_topic") {
      setTest_on(test_on.filter((item) => item.id !== chipToDelete.id));
      filterTest = test_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "Percentage") {
      setInitialfields({ fromDate: "", toDate: "" });
      setUpdateChipData((prevChips) =>
        prevChips.filter((chip) => chip.type !== "Percentage")
      );
      shouldReloadChipData = false;
    } else if (chipToDelete.type === "classMode") {
      setClassModes(classModes.filter((item) => item.id !== chipToDelete.id));
      filterClassMode = classModes.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "medium") {
      setMedium(mediums.filter((item) => item.id !== chipToDelete.id));
      filterMedium = mediums.filter((item) => item.id !== chipToDelete.id);
    } else {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    }
    if (shouldReloadChipData) {
      loadChipdata();
    }
  };

  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => ({ ...prevState, [name]: dateFilter }));
      const from = name === "FDate" ? dateFilter : appData.FDate;
      const to = name === "TDate" ? dateFilter : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    }
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        startDate: false,
        schedule: false,
        Percentage: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        location: false,
        status: !prevState.status,
      }));
    } else if (boxName === "location") {
      setIsOpen((prevState) => ({
        startDate: false,
        schedule: false,
        Percentage: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: !prevState.location,
      }));
    } else if (boxName === "startDate") {
      setIsOpen((prevState) => ({
        schedule: false,
        Percentage: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        startDate: !prevState.startDate,
      }));
    } else if (boxName === "schedule") {
      setIsOpen((prevState) => ({
        Percentage: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        startDate: false,
        schedule: !prevState.schedule,
      }));
    } else if (boxName === "Percentage") {
      setIsOpen((prevState) => ({
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        startDate: false,
        schedule: false,
        Percentage: !prevState.Percentage,
      }));
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        medium: false,
        classMode: false,
        status: false,
        location: false,
        startDate: false,
        schedule: false,
        Percentage: false,
        category: !prevState.category,
      }));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        medium: false,
        classMode: false,
        status: false,
        location: false,
        startDate: false,
        schedule: false,
        Percentage: false,
        subject: !prevState.subject,
        category: false,
        test_topic: false,
      }));
    } else if (boxName === "test_topic") {
      setIsOpen((prevState) => ({
        medium: false,
        classMode: false,
        status: false,
        location: false,
        startDate: false,
        schedule: false,
        Percentage: false,
        test_topic: !prevState.test_topic,
        category: false,
        subject: false,
      }));
    }
    // else if (boxName === "course") {
    //   setIsOpen((prevState) => ({
    //     ...prevState,
    //     course: !prevState.course,
    //   }));
    // }
    else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        classMode: false,
        status: false,
        location: false,
        startDate: false,
        schedule: false,
        Percentage: false,
        category: false,
        medium: !prevState.medium,
      }));
    } else if (boxName === "classMode") {
      setIsOpen((prevState) => ({
        status: false,
        location: false,
        startDate: false,
        schedule: false,
        Percentage: false,
        category: false,
        medium: false,
        classMode: !prevState.classMode,
      }));
    }
  };

  // generate pdf when user click download button
  const generatePDF = () => {
    const headers = [
      "S.No",
      "Event Name",
      "Date",
      "Percentage of Completion",
      "Batch Name",
      "Category",
      "Class Mode",
      "Medium",
      "Location",
    ];
    const rows = csvData.map((item, index) => [
      index + 1,
      item.event_name ?? "-",
      moment(item.date).isValid()
        ? moment(item.date).format("DD/MM/YYYY")
        : "-",
      item.completed_perc ?? "-",
      item.batch_name ?? "-",
      item.category ?? "-",
      item.class_mode === 1 ? "Online" : "Classroom",
      item.medium === 0 ? "English" : "Tamil",
      item.location ?? "-",
    ]);
    navigate("/preview", {
      state: {
        title: "Teaching Progress Data",
        headers,
        rows,
        filename: "TeachingProgress.pdf",
        autoPrint: true,
      },
    });
  };
  // total table data  with pages
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    if (name === "pageCount") {
      setRowsPerPage(parseInt(value));
      setCurrentPage(1);
      setUpdateListData([]);
    }
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  const handleReadView = (id, staff_id, course) => {
    // console.log(id,"id","handleevent");
    navigate(`/ReviewTeachingProgress`, {
      state: {
        id,
        staff_id,
        USERID: userId,
        INDEX: 2,
        SEARCHTERM: searchTerm,
        DATE: appOn,
        PERCENTAGE: initialfields,
        CATEGORY: category_on,
        SUBJECT: subject_on,
        TESTTOPIC: test_on,
        CLASSMODE: classModes,
        MEDIUM: mediums,
        LOCATION: location,
        STAFFNAVTYPE: params.type,
      },
    });
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Event Name", key: "event_name" },
    { label: "Date", key: "date" },
    { label: "Percentage of Completion", key: "completed_perc" },
    { label: "Batch Name", key: "batch_name" },
    { label: "Category", key: "category" },
    { label: "Class Mode", key: "class_mode" },
    { label: "Medium", key: "medium" },
    { label: "Location", key: "location" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div
        className={`${styles.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid  global_container p-0`}
      >
        {/* ---------------------------------------------------------------- */}
        <div className="row ">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div class="input-group ">
              <input
                ref={txtBSearch}
                type="text"
                class={styles.Inputs}
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by event name"
                onKeyDown={handleSearch}
              />
              <span
                class={styles.input_group_text}
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span className="material-icons" onClick={handleSearchFocus}>
                  search
                </span>
              </span>
            </div>
          </div>

          <div className="col-md-8 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"TeachingProgress.csv"}
                  csvName="Download as CSV"
                />
              </li>
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className="primaryButton "
                  variant="primary"
                  onClick={generatePDF}
                >
                  <span className="material-icons me-2 fs-4 align-middle text-white">
                    file_download
                  </span>
                  <span className="text-white">Download as PDF</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {updateChipData?.length > 0 && (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData?.map((data, index) => {
                  let icon;
                  let key = "" + data.name;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

                <ListItem className="clearAll_list">
                  <a
                    className="clearAll_listItem"
                    onClick={() => {
                      handleAllClear();
                    }}
                  >
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        )}

        <div className="row mt-2">
          <div className="col-md-12 table-responsive tableMinHeight ">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No. */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  {/* Event Name */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "event_name")}
                    >
                      {" "}
                      Event Name
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "event_name")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  {/* DATE */}
                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "date")}
                    >
                      Date
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "date")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      onClick={(e) => handleFilter(e, "startDate")}
                      class={` align-middle material-icons ${
                        (appData &&
                          Object.entries(appData).some(
                            ([key, val]) =>
                              key !== "name" &&
                              val !== null &&
                              val !== undefined &&
                              val.toString().trim() !== ""
                          )) ||
                        isOpen.startDate
                          ? "active_icons"
                          : ""
                      }`}
                    >
                      filter_list
                    </span>
                    {isOpen.startDate === true && (
                      <div
                        className="filterBoxOne filter_mmm container p-1"
                        ref={filterLastRef}
                        style={{ width: "240px", height: "332px" }}
                      >
                        <div
                          className=" BathDet "
                          style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
                        >
                          <div className="row mt-1">
                            <div className="col-md-12">
                              <div class="form-check p-1">
                                <label
                                  htmlFor="FDate"
                                  className="d-flex form-label "
                                  style={{
                                    textAlign: "left",
                                    fontSize: "var(--fontSizeFourteen)",
                                    fontWeight: "var(--boldtextWeight)",
                                    fontFamily: "var(--fontfamily2)",
                                    letterSpacing: "0.28px",
                                    color: "var(--colorBlue)",
                                    opacity: 1,
                                  }}
                                >
                                  From Date
                                  <span
                                    data-required="true"
                                    aria-hidden="true"
                                  ></span>
                                </label>
                                <DatePickerSample
                                  IconInput={"filterIocnBoxInput"}
                                  class={"FilterInputs"}
                                  name={"FDate"}
                                  handleChange={handleChangeDate}
                                  fieldInput={appData.FDate}
                                  txtAdMDob={fDatePickerRef}
                                  // maxDate={new Date()}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row mt-1">
                            <div className="col-md-12">
                              <div class="form-check p-1">
                                <label
                                  htmlFor="TDate "
                                  className="d-flex form-label "
                                  style={{
                                    textAlign: "left",
                                    fontSize: "var(--fontSizeFourteen)",
                                    fontWeight: "var(--boldtextWeight)",
                                    fontFamily: "var(--fontfamily2)",
                                    letterSpacing: "0.28px",
                                    color: "var(--colorBlue)",
                                    opacity: 1,
                                  }}
                                >
                                  To Date
                                  <span
                                    data-required="true"
                                    aria-hidden="true"
                                  ></span>
                                </label>
                                <DatePickerSample
                                  class={"FilterInputs"}
                                  IconInput={"filterIocnBoxInput"}
                                  name={"TDate"}
                                  handleChange={handleChangeDate}
                                  fieldInput={appData.TDate}
                                  txtAdMDob={tDatePickerRef}
                                  minDate={appData.FDate}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2 mb-2">
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                id="Today"
                                value="Today"
                                checked={appData.Days === "Today"}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Today"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Today
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                id="Yesterday"
                                value="Yesterday"
                                checked={appData.Days === "Yesterday"}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Yesterday"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Yesterday
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Tweek"
                                checked={appData.Days === "Tweek"}
                                id="Tweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Tweek"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                This week
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Lweek"
                                checked={appData.Days === "Lweek"}
                                id="Lweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Lweek"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Last week
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Tmonth"
                                checked={appData.Days === "Tmonth"}
                                id="Tmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Tmonth"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                This month
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                checked={appData.Days === "Lmonth"}
                                value="Lmonth"
                                id="Lmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Lmonth"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Last month
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleClear("appliedOn")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("appliedOn")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>

                  {/* Percentage of Completion */}
                  <th id="th" ref={percentage_of_completion}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "completed_perc")}
                    >
                      {" "}
                      Percentage of Completion
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "completed_perc")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      className={`textHead_th align-middle material-icons ${
                        initialfields.fromDate ||
                        initialfields.toDate ||
                        isOpen.Percentage
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "Percentage")}
                    >
                      filter_list
                    </span>
                    {isOpen.Percentage && (
                      <>
                        <div
                          className="filterBoxs_testlist"
                          style={{ top: "35px" }}
                        >
                          <div className="col-md-12 form-check filterStatus_list overflow-hidden">
                            <div className="row mt-2">
                              <div>
                                <label for="bookName" class=" confirm_value ">
                                  Start
                                </label>
                              </div>
                              <div className="col-md-12 mb-2 px-3">
                                <input
                                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                  type="number"
                                  id="fromDate"
                                  name="fromDate"
                                  maxLength={50}
                                  placeholder="Enter the from percentage"
                                  value={initialfields.fromDate}
                                  onChange={handleChange}
                                  onWheel={(e) => e.target.blur()}
                                />
                              </div>
                              <div className="col-md-12 mb-2 px-3">
                                <div>
                                  <label for="bookName" class=" confirm_value ">
                                    End
                                  </label>
                                </div>

                                <input
                                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                  type="number"
                                  id="toDate"
                                  name="toDate"
                                  maxLength={50}
                                  placeholder="Enter the to percentage"
                                  value={initialfields.toDate}
                                  onChange={handleChange}
                                  onWheel={(e) => e.target.blur()}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("Percentage")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() =>
                                    handleApplyFilter("Percentage")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                    {/* {isOpen.Percentage === true && (
                      <div className="filterBoxs p-1 mt-3">
                        <div className="row ">
                          <div className="col-md-12">
                            <div>
                              <div>
                                <label for="bookName" class="form-label confirm_value ">
                                  From
                                </label>
                              </div>
                              <input
                                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                type="number"
                                id="fromDate"
                                name="fromDate"
                                maxLength={50}
                                placeholder="Enter the from percentage"
                                value={initialfields.fromDate}
                                onChange={handleChange}
                                onWheel={(e) => e.target.blur()}
                              />
                            </div>
                            <div>
                              <div>
                                <label for="bookName" class="form-label confirm_value ">
                                  To
                                </label>
                              </div>
                              <input
                                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                type="number"
                                id="toDate"
                                name="toDate"
                                maxLength={50}
                                placeholder="Enter the to percentage"
                                value={initialfields.toDate}
                                onChange={handleChange}
                                onWheel={(e) => e.target.blur()}
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("Percentage")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("Percentage")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )} */}
                  </th>

                  {/* Batch Name */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      {" "}
                      Batch Name
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  {/* Category */}
                  <th id="th" ref={filterCategoryRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "category")}
                    >
                      Category
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "category")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        category_on.length > 0 || isOpen.category
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "category")}
                    >
                      filter_list
                    </span>

                    {isOpen.category && (
                      <>
                        <div
                          className="filterBoxs_testlist"
                          style={{ top: "35px", minWidth: "240px" }}
                        >
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              {categoryId.map((cat) => (
                                <li key={cat.name} className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={cat.name}
                                    value={cat.id}
                                    id={cat.name}
                                    checked={category_on.some((element) => {
                                      if (element.name == cat.name) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        cat.name,
                                        "category"
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label filterChipText_withoutBG"
                                    htmlFor={cat.name}
                                  >
                                    {cat.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("category")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleApplyFilter("category")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  {/* Subjects */}
                  <th id="th" ref={filterRef_subject}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "subject")}
                    >
                      Subject
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "subject")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        subject_on.length > 0 || isOpen.subject
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "subject")}
                    >
                      filter_list
                    </span>

                    {isOpen.subject && (
                      <>
                        <div className="filterBoxs_testlist mt-3">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              {/* <li
                                className={`filterListData ${ListInfo.searchInputSec}`}>
                                <input
                                  className={`${ListInfo.searchInput} w-100`}
                                  type="text"
                                  placeholder="Search by subject"
                                  name="search_book_title"
                                  onKeyDown={(e) =>
                                    handleFilterCourseSearch(e, "subject")
                                  }
                                  ref={txtBSearch_subj}
                                />
                                <Search
                                  onClick={() =>
                                    handleFilterSearchFocus("subject")
                                  }
                                  className={`${ListInfo.ListsearchIcon}`}
                                />
                              </li> */}
                              {subjectIds.map((el) => (
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={el.subject_name}
                                    value={el.subject_id}
                                    id={el.subject_name}
                                    checked={subject_on.some((element) => {
                                      if (element.id == el.subject_id) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        el.subject_name,
                                        "subject"
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label filterChipText_withoutBG "
                                    htmlFor={el.subject_name}
                                  >
                                    {el.subject_name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("subject")}
                                  className="secondaryButton "
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    subject_on.length === 0 ? true : false
                                  }
                                  onClick={() => handleApplyFilter("subject")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* <div
                        ref={filterRef_subject}
                        className={`${ListInfo.overlayBookFilter} ${isOpen.subject ? "active" : ""
                          }`}
                      ></div> */}
                      </>
                    )}
                  </th>
                  {/* Test Topics */}
                  <th id="th" ref={filterRef_test_topic}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "test_topic")}
                    >
                      Test Topic
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "test_topic")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        test_on.length > 0 || isOpen.test_topic
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "test_topic")}
                    >
                      filter_list
                    </span>

                    {isOpen.test_topic && (
                      <>
                        <div className="filterBoxs_testlist mt-3">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              {/* <li
                                className={`filterListData ${ListInfo.searchInputSec}`}>
                                <input
                                  className={`${ListInfo.searchInput} w-100`}
                                  type="text"
                                  placeholder="Search by subject"
                                  name="search_book_title"
                                  onKeyDown={(e) =>
                                    handleFilterCourseSearch(e, "subject")
                                  }
                                  ref={txtBSearch_subj}
                                />
                                <Search
                                  onClick={() =>
                                    handleFilterSearchFocus("subject")
                                  }
                                  className={`${ListInfo.ListsearchIcon}`}
                                />
                              </li> */}
                              {testIds.map((el) => (
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={el.test_topic_name}
                                    value={el.test_topic_id}
                                    id={el.test_topic_name}
                                    checked={test_on.some((element) => {
                                      if (element.id == el.test_topic_id) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        el.test_topic_name,
                                        "test_topic"
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label filterChipText_withoutBG "
                                    htmlFor={el.test_topic_name}
                                  >
                                    {el.test_topic_name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("test_topic")}
                                  className="secondaryButton "
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    subject_on.length === 0 ? true : false
                                  }
                                  onClick={() =>
                                    handleApplyFilter("test_topic")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* <div
                        ref={filterRef_subject}
                        className={`${ListInfo.overlayBookFilter} ${isOpen.subject ? "active" : ""
                          }`}
                      ></div> */}
                      </>
                    )}
                  </th>
                  {/* Class Mode */}
                  <th id="th" ref={filterClassModeRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "class_mode")}
                    >
                      Class Mode
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "class_mode")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        classModes.length > 0 || isOpen.classMode
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "classMode")}
                    >
                      filter_list
                    </span>

                    {isOpen.classMode && (
                      <>
                        <div
                          className="filterBoxs_testlist"
                          style={{ top: "35px", minWidth: "240px" }}
                        >
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Online"
                                  value="1"
                                  id="Online"
                                  checked={classModes.some((element) => {
                                    if (element.name === "Online") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "Online")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG"
                                  for="defaultCheck1"
                                  htmlFor="Online"
                                >
                                  Online
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Classroom"
                                  value="0"
                                  id="Classroom"
                                  checked={classModes.some((element) => {
                                    if (element.name === "Classroom") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "Classroom")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG"
                                  for="defaultCheck1"
                                  htmlFor="Classroom"
                                >
                                  Classroom
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("classMode")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleApplyFilter("classMode")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  {/* Medium */}
                  <th id="th" ref={filterRef_medium}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "medium")}
                    >
                      Medium
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "medium")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        mediums.length > 0 || isOpen.medium
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "medium")}
                    >
                      filter_list
                    </span>

                    {isOpen.medium && (
                      <>
                        <div
                          className="filterBoxs_testlist"
                          style={{ top: "35px", minWidth: "240px" }}
                        >
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Tamil"
                                  value="1"
                                  id="Tamil"
                                  checked={mediums.some((element) => {
                                    if (element.id === "1") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "Tamil")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG"
                                  for="defaultCheck1"
                                  htmlFor="Tamil"
                                >
                                  Tamil
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="English"
                                  value="0"
                                  id="English"
                                  checked={mediums.some((element) => {
                                    if (element.id === "0") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "English")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG"
                                  for="defaultCheck1"
                                  htmlFor="English"
                                >
                                  English
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("medium")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleApplyFilter("medium")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  {/* LOCATION */}
                  <th id="th" ref={filterLocationRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "location")}
                    >
                      Location
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "location")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        location.length > 0 || isOpen.location
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "location")}
                    >
                      filter_list
                    </span>

                    {isOpen.location && (
                      <>
                        <div
                          className="filterBoxs_testlist"
                          style={{ top: "35px", minWidth: "240px" }}
                        >
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              {locationOptions.map((loc, index) => (
                                <li className="filterListData" key={loc.id}>
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={loc.label}
                                    value={loc.value}
                                    id={`location-${index}`}
                                    checked={location.some(
                                      (item) => item.id === String(loc.value)
                                    )}
                                    onChange={(e) =>
                                      handleCheckboxChange(e, "location")
                                    }
                                    // onChange={(e) =>
                                    //   handleCheckboxChange(
                                    //     e,
                                    //     "location",
                                    //     "location"
                                    //   )
                                    // }
                                  />
                                  <label
                                    className="form-check-label filterChipText_withoutBG"
                                    htmlFor={`location-${index}`}
                                  >
                                    {loc.label}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("location")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleApplyFilter("location")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  <th id="th">
                    <span className="textHead_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData?.map((course, index) => (
                    <tr key={index}>
                      <td id="td">{course.serialNumber}</td>
                      <td id="td">
                        {course.comment === 1 && user_type === 3 && (
                          <small className="active_comment"></small>
                        )}
                        {course.event_name}
                      </td>
                      <td id="td">
                        {moment(course.date).format("DD/MM/YYYY")}
                      </td>
                      <td id="td"> {course.completed_perc}</td>
                      <td id="td">
                        {course.batch_name}({course.section})
                      </td>
                      <td id="td">{course.category}</td>
                      <td id="td">
                        <span
                          title={
                            course.subject && course.subject.length > 0
                              ? course.subject
                                  .map((subject) => subject.subject)
                                  .join(", ")
                              : "_"
                          }
                          className={styles.ellipsisText}
                        >
                          {course.subject && course.subject.length > 0
                            ? course.subject
                                .map((subject) => subject.subject)
                                .join(", ")
                            : "_"}
                        </span>
                      </td>
                      <td id="td">
                        <span
                          title={
                            course.test_topic && course.test_topic.length > 0
                              ? course.test_topic
                                  .map((test_topic) => test_topic.test_topic)
                                  .join(", ")
                              : "_"
                          }
                          className={styles.ellipsisText}
                        >
                          {course.test_topic && course.test_topic.length > 0
                            ? course.test_topic
                                .map((test_topic) => test_topic.test_topic)
                                .join(", ")
                            : "_"}
                        </span>
                      </td>
                      <td id="td">{course.class_mode}</td>
                      <td id="td">{course.medium}</td>
                      <td id="td">{course.location}</td>
                      <td id="td">
                        <button
                          className={"view_icon_button"}
                          onClick={() =>
                            handleReadView(
                              course.event_id,
                              course.staff_id,
                              course
                            )
                          }
                        >
                          <span class="material-icons">visibility</span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="CourseInfoSec row mt-3">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              updateListData?.length > 0
                ? updateListData?.length < currentPage * rowsPerPage
                  ? updateListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={updateListData?.length || 0}
            handlePrev={() => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1 || totalPages === 0}
            prevButton="prev_buttonViewEvaluator materialIconsRightAndLeft me-2"
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages || totalPages === 0}
          />
        </div>
      </div>
    </>
  );
}

export default TeachingProgress;
